import React from 'react';
import { isSmallIOSDevice } from 'src/utils/util';
import { BottomNavigationContainer } from './BottomNavigation.styled';

const BottomNavigation = ({
    justifyContent,
    alignItems,
    mobileJustifyContent,
    opacity = 1,
    padding = '1.125rem 1rem',
    width = {},
    position = 'sticky',
    right = '',
    shipToPage,
    mbPosition = 'fixed',
    zIndex = 2000,
    buttonsPosition,
    smallDeviceJustifyContent,
    mbPadding,
    isIPadPotrait,
    iPadPortraitFooterPosition,
    iPadPortraitJustifyContent,
    bottom = '0',
    boxShadow = '0px -3px 6px #00000014',
    borderRadius,
    exSmallDeviceSafeAreaBottom,
    smallDeviceInsetArea,
    flexDirection,
    height,
    portraitPosition,
    portraitBottom,
    children,
    justifyContentCenter,
    paddingBottom,
    fromAccountPage,
    selectedTabIdAccount,
    fromTemplate,
    mbLeft,
    isReportProcedureDataFooter,
    isConsignmentBilling,
    isConsignmentReturn,
    inventoryWidth,
    isInventoryFooter,
    isFromPhysicianDetails,
    overridePaddingBottom,
    setsFilterFooter = false,
}) => {
    const smallIOSDevice = isSmallIOSDevice();
    return (
        <BottomNavigationContainer
            setsFilterFooter={setsFilterFooter}
            desktopJustifyContent={justifyContent}
            alignItems={alignItems}
            isInventoryFooter={isInventoryFooter}
            mobileJustifyContent={mobileJustifyContent}
            isReportProcedureDataFooter={isReportProcedureDataFooter}
            opacity={opacity}
            padding={padding}
            width={width}
            position={position}
            right={right}
            mbLeft = {mbLeft}
            shipToPage={shipToPage}
            mbPosition={mbPosition}
            zIndex={zIndex}
            buttonsPosition={buttonsPosition}
            smallDeviceJustifyContent={smallDeviceJustifyContent}
            mbPadding={mbPadding}
            isIPadPotrait={isIPadPotrait}
            iPadPortraitFooterPosition={iPadPortraitFooterPosition}
            iPadPortraitJustifyContent={iPadPortraitJustifyContent}
            bottom={bottom}
            boxShadow={boxShadow}
            borderRadius={borderRadius}
            exSmallDeviceSafeAreaBottom={exSmallDeviceSafeAreaBottom}
            smallDeviceInsetArea={smallDeviceInsetArea}
            flexDirection={flexDirection}
            smallIOSDevice={smallIOSDevice}
            height={height}
            portraitPosition={portraitPosition}
            portraitBottom={portraitBottom}
            justifyContentCenter={justifyContentCenter}
            paddingBottom={paddingBottom}
            overridePaddingBottom={overridePaddingBottom}
            fromAccountPage={fromAccountPage}
            selectedTabIdAccount={selectedTabIdAccount}
            isFromTemplates={fromTemplate}
            isConsignmentBilling={isConsignmentBilling}
            isConsignmentReturn={isConsignmentReturn} 
            inventoryWidth={inventoryWidth}
            isFromPhysicianDetails={isFromPhysicianDetails}
            >
            {children}
        </BottomNavigationContainer>
    );
};

export default BottomNavigation;
